import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", path: "/" },
  { label: "八卦", path: "/gossip" },
  { label: "黑料", path: "/black" },
  { label: "新闻", path: "/news" },
  { label: "关于", path: "/about" },
  { label: "联系", path: "/contact" },
];

export default function SiteHeader() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  const [mobileKeyword, setMobileKeyword] = useState("");

  const handleSearch = (event: React.FormEvent<HTMLFormElement>, value: string) => {
    event.preventDefault();
    const trimmed = value.trim();
    if (!trimmed) return;
    setMenuOpen(false);
    navigate(`/search?q=${encodeURIComponent(trimmed)}`);
  };

  return (
    <header className="sticky top-0 z-50 w-full">
      <div className="hidden md:block bg-primary-950 text-background-200">
        <div className="flex items-center justify-between h-9 px-4 md:px-6 text-[12px]">
          <div className="flex items-center gap-4">
            <span className="text-background-300">2026 年 10 月 17 日 星期六</span>
            <span className="w-px h-3 bg-background-50/20" />
            <span className="text-accent-300">娱乐不眠，吃瓜有理</span>
          </div>
          <div className="flex items-center gap-5">
            <Link to="/search?q=爆料" className="hover:text-accent-300 transition-colors cursor-pointer">
              热搜榜
            </Link>
            <Link to="/about" className="hover:text-accent-300 transition-colors cursor-pointer">
              关于我们
            </Link>
            <Link
              to="/contact"
              className="flex items-center gap-1 text-accent-300 hover:text-accent-200 transition-colors cursor-pointer"
            >
              <i className="ri-megaphone-line" />
              爆料线索投递
            </Link>
          </div>
        </div>
      </div>

      <div className="bg-background-50/95 backdrop-blur-md border-b border-background-200">
        <div className="flex items-center gap-4 h-16 md:h-[74px] px-4 md:px-6">
          <Link to="/" className="flex items-center gap-2.5 shrink-0 cursor-pointer" aria-label="黑料吃瓜首页">
            <span className="w-9 h-9 md:w-10 md:h-10 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-fire-line text-accent-400 text-xl md:text-2xl" />
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg md:text-[22px] font-black tracking-tight text-primary-950 whitespace-nowrap">
                黑料吃瓜
              </span>
              <span className="text-[10px] tracking-[0.24em] text-foreground-500 mt-1 whitespace-nowrap">
                ENTERTAINMENT INSIGHT
              </span>
            </span>
          </Link>

          <nav className="hidden lg:flex items-center gap-1 ml-6" aria-label="主导航">
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === "/"}
                className={({ isActive }) =>
                  `px-3 py-2 rounded-md text-[15px] font-medium whitespace-nowrap transition-colors cursor-pointer ${
                    isActive
                      ? "text-accent-600 bg-accent-50"
                      : "text-foreground-700 hover:text-primary-600 hover:bg-primary-50"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2 md:gap-3 ml-auto">
            <form
              onSubmit={(event) => handleSearch(event, keyword)}
              className="hidden md:flex items-center bg-background-100 border border-background-200 rounded-full pl-3.5 pr-1 py-1 w-44 lg:w-60 focus-within:border-primary-300 transition-colors"
            >
              <i className="ri-search-line text-foreground-400 text-sm" />
              <input
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                type="search"
                name="q"
                placeholder="搜索明星 / 事件"
                className="flex-1 bg-transparent outline-none border-none text-sm text-foreground-800 placeholder:text-foreground-400 px-2 py-1"
              />
              <button
                type="submit"
                className="w-7 h-7 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-xs cursor-pointer hover:bg-primary-600 transition-colors"
                aria-label="搜索"
              >
                <i className="ri-arrow-right-line" />
              </button>
            </form>

            <Link
              to="/contact"
              className="hidden sm:inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-accent-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-accent-600 transition-colors cursor-pointer"
            >
              <i className="ri-flashlight-line" />
              我要爆料
            </Link>

            <button
              type="button"
              onClick={() => setMenuOpen((prev) => !prev)}
              className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-200 text-foreground-800 cursor-pointer hover:bg-background-100 transition-colors"
              aria-label="打开菜单"
              aria-expanded={menuOpen}
            >
              <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
            </button>
          </div>
        </div>

        {menuOpen && (
          <div className="lg:hidden border-t border-background-200 bg-background-50 px-4 pb-4 pt-3 animate-fadeIn">
            <form
              onSubmit={(event) => handleSearch(event, mobileKeyword)}
              className="flex items-center bg-background-100 border border-background-200 rounded-full pl-3.5 pr-1 py-1 mb-3"
            >
              <i className="ri-search-line text-foreground-400 text-sm" />
              <input
                value={mobileKeyword}
                onChange={(event) => setMobileKeyword(event.target.value)}
                type="search"
                placeholder="搜索明星 / 事件 / 关键词"
                className="flex-1 bg-transparent outline-none border-none text-sm px-2 py-1.5 text-foreground-800 placeholder:text-foreground-400"
              />
              <button
                type="submit"
                className="w-8 h-8 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-sm cursor-pointer"
                aria-label="搜索"
              >
                <i className="ri-arrow-right-line" />
              </button>
            </form>
            <div className="grid grid-cols-3 gap-2">
              {navItems.map((item) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  end={item.path === "/"}
                  onClick={() => setMenuOpen(false)}
                  className={({ isActive }) =>
                    `py-2.5 rounded-md text-sm text-center font-medium cursor-pointer transition-colors ${
                      isActive
                        ? "bg-primary-500 text-background-50"
                        : "bg-background-100 text-foreground-700 hover:bg-primary-50"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </div>
          </div>
        )}
      </div>
    </header>
  );
}